<template>
  <div class="reward">
    <div class="question">{{ $t('promotion_new.reward_type') }}</div>
    <div class="radios">
      <div class="radio">
        <input id="chk_percent" type="radio" value="%" v-model="promotion.rewardType">
        <label for="chk_percent" v-html="$t('percent')"></label>
        <input id="chk_flat" type="radio" value="$" v-model="promotion.rewardType">
        <label for="chk_flat" v-html="$t('flat')"></label>
        <template v-if="showReplace">
          <input id="chk_replace" type="radio" value="replace" v-model="promotion.rewardType">
          <label for="chk_replace">{{ $t('replace') }}</label>
        </template>
      </div>
    </div>
    <template v-if="promotion.rewardType === '%'">
      <div class="question">{{ $t('promotion_new.product_percent') }}</div>
      <div class="input-group">
        <input type="number" step="0.01" v-model="promotion.rewardAmount">
        <div class="input-overlay">%</div>
      </div>
    </template>
    <template v-if="promotion.rewardType === '$'">
      <div class="question">{{ $t('promotion_new.product_flat') }}</div>
      <div class="input-group">
        <input type="number" step="0.01" v-model="promotion.rewardAmount">
        <div class="input-overlay">{{ currencySymbol }}</div>
      </div>
    </template>
    <template v-if="promotion.rewardType === 'replace'">
      <div class="question">{{ $t('promotion_new.product_replace') }}</div>
      <div class="input-group">
        <input type="number" step="0.01" v-model="promotion.rewardAmount">
        <div class="input-overlay">{{ currencySymbol }}</div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "PromotionReward",

  props: {
    promotion: Object,
    showReplace: Boolean,
    currencySymbol: String
  }
}
</script>